<template>
  <div class="c-batch-table">
    <Spin size="large" fix v-if="loading" />
    <el-table ref="table" height="100%" border :data="data" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :fixed="true" width="39"></el-table-column>
      <el-table-column prop="index" :fixed="true" label="序号" width="45">
        <template slot-scope="scope">
          <span>{{ scope.row['index'] + 1 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="project" :fixed="true" width="308">
        <template slot="header">
          <span>项目名称</span>
        </template>
        <template slot-scope="scope">
          <Input disabled v-model="scope.row['project']" :style="{ width: 280 }" />
        </template>
      </el-table-column> -->
      <el-table-column prop="plan" :fixed="true" width="340">
        <template slot="header">
          <span>广告名称</span>
          <ul class="m-dynamic">
            <li v-for="(word, i) in dynwords" :key="i">
              <a href="javascript:;" @click.stop="appendTrend(word)">+{{ word }}</a>
            </li>
          </ul>
        </template>
        <template slot-scope="scope">
          <input-len
            :ref="`planinput${scope.row['index']}`"
            v-model="scope.row['plan']"
            placeholder="最大90个字符，1个中文等于2个字符"
            width="280"
            :max="90"
            :dyn-pos="scope.row['dynpos']"
            @on-focus="focusPlan(scope.row['index'])"
            @on-blur="blurPlan"
            @on-del-trend="$emit('on-delete-trend', scope.row['index'])"
            @change="changePlanName(scope.row['index'], ...arguments)"
          />
          <dd class="dynamic-error g-error-text" v-html="scope.row['dynerr']"></dd>
        </template>
      </el-table-column>
      <!-- 广告账号 -->
      <el-table-column width="166">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="accountAll" @on-change="selectAll('account', ...arguments)">广告账号</Checkbox>
            <Button @click="handleBatch('account')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_account']" @on-change="changeAccount(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('account', scope.row['index'])">{{ scope.row['account'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="126" v-if="isLive && false" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="castTargetAll" @on-change="selectAll('castTarget', ...arguments)"
              ><span class="g-error-text">投放目标</span></Checkbox
            >
            <Button @click="handleBatch('castTarget')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_castTarget']" @on-change="changeCastTarget(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('castTarget', scope.row['index'])">{{ scope.row['castTarget'] }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="target" width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="targetAll" @on-change="selectAll('target', ...arguments)">项目组合名称</Checkbox>
            <Button @click="handleBatch('target')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_target']" @on-change="changeTarget(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('target', scope.row['index'])">{{ scope.row['target'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="retargetAll" @on-change="selectAll('retarget', ...arguments)">人群包(选填)</Checkbox>
            <Button @click="handleBatch('retarget')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_retarget']" @on-change="changeReTarget(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('retarget', scope.row['index'])">{{ scope.row['retarget'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="creativeAll" @on-change="selectAll('creative', ...arguments)">广告组合名称</Checkbox>
            <Button @click="handleBatch('creative')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_creative']" @on-change="changeCreative(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('creative', scope.row['index'])">{{ scope.row['creative'] }}</a>
        </template>
      </el-table-column>

      <el-table-column width="126" v-if="isShowLdy" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="landingPageAll" @on-change="selectAll('landingPage', ...arguments)"
              ><span class="g-error-text">落地页</span></Checkbox
            >
            <Button @click="handleBatch('landingPage')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_landingPage']" @on-change="changeLandingPage(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('landingPage', scope.row['index'])">{{ scope.row['landingPage'] }}</a>
        </template>
      </el-table-column>

      <el-table-column width="126" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="carouselMmaterialAll" @on-change="selectAll('carouselMmaterial', ...arguments)">
              <span>图文</span>
            </Checkbox>
            <Button @click="handleBatch('carouselMmaterial')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_carouselMmaterial']" @on-change="changeCarouselMmaterial(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('carouselMmaterial', scope.row['index'])">{{ scope.row['carouselMmaterial'] }}</a>
        </template>
      </el-table-column>

      <el-table-column width="140" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="nativeSettingAll" @on-change="selectAll('nativeSetting', ...arguments)">推广身份</Checkbox>
            <Button @click="handleBatch('nativeSetting')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_nativeSetting']" @on-change="changeNativeSetting(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('nativeSetting', scope.row['index'])">{{ scope.row['nativeSetting'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="nativeAnchorAll" @on-change="selectAll('nativeAnchor', ...arguments)">原生锚点</Checkbox>
            <Button @click="handleBatch('nativeAnchor')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_nativeAnchor']" @on-change="changeNativeAnchor(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('nativeAnchor', scope.row['index'])">{{ scope.row['nativeAnchor'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="convertAll" @on-change="selectAll('convert', ...arguments)">事件管理优化目标</Checkbox>
            <Button @click="handleBatch('convert')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_convert']" @on-change="changeConvert(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('convert', scope.row['index'])">{{ scope.row['convert'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="126" v-if="isShowBudget">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="budgetAll" @on-change="selectAll('budget', ...arguments)">预算</Checkbox>
            <Button @click="handleBatch('budget')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_budget']" @on-change="changeBudget(scope.row['index'], ...arguments)" />
          <InputNumber
            :value="scope.row['budget'] || 0"
            :min="300"
            :max="9999999.99"
            :step="100"
            :precision="2"
            :active-change="false"
            placeholder="请输入预算金额"
            style="width: 80px"
            @on-change="changeBudgetInput(scope.row['index'], ...arguments)"
          />
        </template>
      </el-table-column>
      <el-table-column width="280">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="bidAll" @on-change="selectAll('bid', ...arguments)">出价</Checkbox>
            <Button @click="handleBatch('bid')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="bid-cell-box">
            <Checkbox v-model="scope.row['_bid']" @on-change="changeBid(scope.row['index'], ...arguments)" />
            <bid-batch
              :smart-bid-type="scope.row['bid']['smart_bid_type']"
              :adjust-cpa="scope.row['bid']['adjust_cpa']"
              :deep-bid-type="scope.row['bid']['deep_bid_type']"
              :bid-range="scope.row['bid']['bid_range']"
              :deep-cpabid-range="scope.row['bid']['deep_cpabid_range']"
              :pricing="scope.row['bid']['pricing']"
              :deep-cpabid="scope.row['bid']['deep_cpabid']"
              :roi-goal="scope.row['bid']['roi_goal']"
              :cpa-bid="scope.row['bid']['cpa_bid']"
              :bid="scope.row['bid']['bid']"
              :bid-type="bidType"
              @on-click="handleBatch('bid', scope.row['index'])"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip v-if="false">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="creativeCompAll" @on-change="selectAll('creativeComp', ...arguments)">创意组件</Checkbox>
            <Button @click="handleBatch('creativeComp')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_creativeComp']" @on-change="changeCreativeComp(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('creativeComp', scope.row['index'])">{{ scope.row['creativeComp'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip v-if="false">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="pagespecAll" @on-change="selectAll('pagespec', ...arguments)">试玩素材（选填）</Checkbox>
            <Button @click="handleBatch('pagespec')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_pagespec']" @on-change="changePagespec(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatchUrl('pagespec', scope.row['index'])" @dblclick="showUrl(scope.row['pagespec'])">{{
            scope.row['pagespec']
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="control" label="操作" min-width="104">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="$emit('on-delete', scope.row['index'])" class="c-control-margin">删除</el-button>
          <el-button type="text" size="small" @click="$emit('on-copy', scope.$index)" class="c-control-margin">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
import InputLen from '@/components/input/input-len'
import BidBatch from './bid-batch.vue'

let DTIME = null

export default {
  name: 'batchTable',
  components: { InputLen, BidBatch },
  props: {
    data: {
      type: Array,
      required: true
    },
    isShowLdy: {
      type: Boolean
    },
    isLive: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    dynwords: {
      type: Array,
      required: true
    },
    bidType: {
      type: String
    },
    isShowBudget: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    accountAll() {
      return this.data.every((ret) => ret && ret._account)
    },
    campaignAll() {
      return this.data.every((ret) => ret && ret._campaign)
    },
    targetAll() {
      return this.data.every((ret) => ret && ret._target)
    },
    retargetAll() {
      return this.data.every((ret) => ret && ret._retarget)
    },
    creativeAll() {
      return this.data.every((ret) => ret && ret._creative)
    },
    convertAll() {
      return this.data.every((ret) => ret && ret._convert)
    },
    castTargetAll() {
      return this.data.every((ret) => ret && ret._castTarget)
    },
    landingPageAll() {
      return this.data.every((ret) => ret && ret._landingPage)
    },
    carouselMmaterialAll() {
      return this.data.every((ret) => ret && ret._carouselMmaterial)
    },
    pagespecAll() {
      return this.data.every((ret) => ret && ret._pagespec)
    },
    creativeCompAll() {
      return this.data.every((ret) => ret && ret._creativeComp)
    },
    nativeSettingAll() {
      return this.data.every((ret) => ret && ret._nativeSetting)
    },
    nativeAnchorAll() {
      return this.data.every((ret) => ret && ret._nativeAnchor)
    },
    budgetAll() {
      return this.data.every((ret) => ret && ret._budget)
    },
    bidAll() {
      return this.data.every((ret) => ret && ret._bid)
    }
  },
  // watch: {
  //   data: {
  //     handler(nVal) {
  //       console.log(nVal)
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    selectAll() {
      const type = arguments[0]
      const val = arguments[1]
      this.$emit('on-select-all', { type, val })
    },
    changeTarget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'target', val: [index, bool] })
    },
    changeAccount() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'account', val: [index, bool] })
    },
    changeCampaign() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'campaign', val: [index, bool] })
    },
    changeReTarget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'retarget', val: [index, bool] })
    },
    changeCreative() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'creative', val: [index, bool] })
    },
    changeCastTarget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'castTarget', val: [index, bool] })
    },
    changeLandingPage() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'landingPage', val: [index, bool] })
    },
    changeCarouselMmaterial() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'carouselMmaterial', val: [index, bool] })
    },
    changeNativeSetting() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'nativeSetting', val: [index, bool] })
    },
    changeNativeAnchor() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'nativeAnchor', val: [index, bool] })
    },
    changeCreativeComp() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'creativeComp', val: [index, bool] })
    },
    changePagespec() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'pagespec', val: [index, bool] })
    },
    changeConvert() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'convert', val: [index, bool] })
    },
    changeBudget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'budget', val: [index, bool] })
    },
    changeBid() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'bid', val: [index, bool] })
    },
    changePlanName() {
      const index = arguments[0]
      const value = arguments[1]
      this.$emit('on-change', [index, value])
    },
    handleSelectionChange(selection) {
      this.$emit('on-selection', selection)
    },
    handleBatch(type, index) {
      this.$emit('on-batch', [type, index])
    },
    handleBatchUrl(type, index) {
      clearTimeout(DTIME)
      DTIME = setTimeout(() => {
        this.handleBatch(type, index)
      }, 300) // 300 单击事件
    },
    changeBudgetInput() {
      const index = arguments[0]
      const val = arguments[1]
      this.$emit('on-batch', ['budget', index, val])
    },
    showUrl(name) {
      clearTimeout(DTIME) // 清除
      if (name.includes('未配置')) return
      window.open(name, '_blank')
    },
    appendTrend(word) {
      if (typeof this.scopeIndex !== 'number') {
        this.$Message.error('请先确认插入动态词的位置')
        return
      }
      this.$emit('on-trend', [this.scopeIndex, word, this.selectionStart])
      // this.$refs[`planinput${this.scopeIndex}`].focus()
    },
    focusPlan(index) {
      this.scopeIndex = index
      if (DTIME) clearTimeout(DTIME)
    },
    blurPlan(start) {
      this.selectionStart = start
      DTIME = setTimeout(() => {
        this.$emit('on-blur', this.scopeIndex)
        timeout().then(() => {
          this.scopeIndex = null
        })
      }, 600)
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-batch-table {
  width: 100%;
  height: calc(100% - 84px);

  .c-custom-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 8px;
  }

  .bid-cell-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .ivu-checkbox-wrapper {
    margin-right: 0;
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-left: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-right: 12px;
    }
  }

  ::v-deep .el-table .cell {
    line-height: 1.2;
  }

  ::v-deep .el-table th .cell {
    max-height: unset !important;
  }
}
</style>
